import getExtensibilityState from '../store/getExtensibilityState';
import type TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';
import getAddinInstanceString from './getAddinInstanceString';
import getAddinInstanceFromControlId from './getAddinInstanceFromControlId';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';

const COMPOSE_HOSTITEM_HEADER = 'extCompose';

export function getTaskPaneRunningInstance(
    type: TaskPaneType,
    hostItemIndex: string,
    targetWindow: Window
): TaskPaneRunningInstance {
    const addinInstanceString: string = getAddinInstanceString(targetWindow, hostItemIndex);
    const { taskPanes } = getExtensibilityState();

    return taskPanes?.get(addinInstanceString)?.get(type);
}

export function getTaskPaneRunningInstanceByControlId(controlId: string): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let instance of taskPaneAddins.values()) {
            if (instance && instance.controlId === controlId) {
                return instance;
            }
        }
    }
    return null;
}

export function getTaskPaneType(controlId: string): TaskPaneType {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let [type, taskPaneInstance] of taskPaneAddins) {
            if (taskPaneInstance && taskPaneInstance.controlId === controlId) {
                return type;
            }
        }
    }
    return null;
}

export function getConverseTaskPaneType(type: TaskPaneType): TaskPaneType {
    return type === TaskPaneType.Persistent ? TaskPaneType.NonPersistent : TaskPaneType.Persistent;
}

export function getFrameworkComponentIdByControlId(controlId: string): string {
    const addinInstanceString: string = getAddinInstanceFromControlId(controlId);
    const addinInstance = JSON.parse(addinInstanceString);
    const { frameworkComponentHostItemIndexMap } = getExtensibilityState();
    for (let [
        frameworkComponentId,
        addinLocation,
    ] of frameworkComponentHostItemIndexMap.entries()) {
        const projection = getProjection(addinLocation.targetWindow);
        const tabId = projection
            ? projection.tabId
            : addinLocation.targetWindow === window
            ? 'Main'
            : null;
        if (addinLocation.hostItemIndex === addinInstance.hostItemIndex) {
            /*
                For compose tabId doesn't matter as we can have only one compose window open at a time
                So we check for compose header and skip matching the tabId
             */
            if (
                addinLocation.hostItemIndex.substring(0, 10) === COMPOSE_HOSTITEM_HEADER ||
                tabId === addinInstance.tabId
            ) {
                return frameworkComponentId;
            }
        }
    }
    return null;
}
